import { List, ListItemButton, Popover } from "@mui/material";
import colors from "theme/themeConstants";
import linkIconRed from "components/icons/share-red.svg";
import privateGifIconRed from "components/icons/privateGifIconRed.svg";
import publicGifIconRed from "components/icons/publicGifIconRed.svg";
import trashcanIconRed from "components/icons/trashcanIconRed.svg";
import galleryIcon from "components/icons/gallery.svg";
// import nicheIcon from "components/icons/FolderAdd2.svg";
import { IGif } from "services/types";

interface IProps {
  gif: IGif;
  anchorEl: HTMLElement | null;
  onShare: () => void;
  onAddToNiche: () => void;
  onChangeVisibility: () => void;
  onDelete: () => void;
  onClose: () => void;
  onEditGallery?: (gallery?: string) => void;
}

export const GifOptionsDesktop = (props: IProps) => {
  const {
    gif,
    anchorEl,
    onShare,
    onDelete,
    // onAddToNiche,
    onChangeVisibility,
    onClose,
    onEditGallery,
  } = props;

  return (
    <Popover
      sx={{
        "& img": { height: "16px", marginRight: "6px" },
      }}
      anchorEl={anchorEl}
      open={true}
      anchorOrigin={{
        vertical: "center",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      PaperProps={{
        sx: {
          boxShadow: "none"
        }
      }}
      onClose={onClose}
    >
      <List>
        <ListItemButton onClick={onShare}>
          <img src={linkIconRed} alt="" />
          <p>Share</p>
        </ListItemButton>

        <ListItemButton onClick={onChangeVisibility}>
          <img
            style={{ fill: colors.redPink }}
            src={gif.published ? privateGifIconRed : publicGifIconRed}
            alt=""
          />
          <p>{`Make ${gif.published ? "private" : "public"}`}</p>
        </ListItemButton>

        {
          onEditGallery && gif.gallery && (
            <ListItemButton onClick={ () => { onEditGallery(gif.gallery); } }>
              <img
                style={{ fill: colors.redPink }}
                src={galleryIcon}
                alt=""
              />
              <p>Edit Gallery</p>
            </ListItemButton>
          )
        }

        <ListItemButton onClick={onDelete}>
          <img
            style={{ fill: colors.redPink }}
            src={trashcanIconRed}
            alt=""
          />
          <p>Delete</p>
        </ListItemButton>
      </List>
    </Popover>
  );
};
